// extracted by mini-css-extract-plugin
module.exports = {"Container":"Loader_Container__2qHqO"};